<template>
    <div class="page-customer">
        <el-card shadow="never" class="m-b-20">
            <el-row :gutter="20">
                <el-col :span="18">
                    <h2 class="m-b-0">{{customerName}}</h2>
                </el-col>
                <el-col :span="6" align="right" v-if="dataTable && dataTable.find(x => x.View.Name === 'CompanyID')">
                    <el-button
                            class="font-weight-bold"
                            @click="$router.push({ name: 'companyDetails', params: { id: dataTable.find(x => x.View.Name === 'CompanyID').ObjectId } })"
                            icon="icon-rotate-ccw"
                    >
                        {{dataTable.find(x => x.View.Name === 'CompanyID').Value}}
                    </el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-row :gutter="20">
            <el-col :sm="24" :md="24" :lg="12" :xl="12" class="m-b-20 m-b-lg-0">
                <el-table v-loading="loading" :data="dataTable">
                    <el-table-column prop="name" label="">
                        <template slot-scope="scope">
                            <div class="font-weight-bold">
                                {{ scope.row.View.DisplayName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="value" label="">
                        <template slot-scope="scope">
                            <Input2 :itemType="itemType" :value="scope.row.Value" :view="scope.row.View" />
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col :sm="24" :md="24" :lg="12" :xl="12">
                <el-table v-loading="loadingCards" :data="cardsTable">
                    <el-table-column prop="Name" label="ID">
                        <template slot-scope="scope">
                            <div class="font-weight-bold">
                                <a href="#" @click.prevent="showDetails(scope.row.ID)" class="color-black">
                                    {{ scope.row.Name }}
                                </a>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Name" label="Тариф" v-if="$mobile()">
                        <template slot-scope="scope">
                            <div v-if="$tarifDict" class="font-weight-bold">
                                {{ ($tarifDict[scope.row.TariffID] ? $tarifDict[scope.row.TariffID].Name : scope.row.TariffID) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="TimeExpiration" label="Истекает" v-if="$mobile()">
                        <template slot-scope="scope">
                            <table-date :date="scope.row.TimeExpiration"/>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Input2 from '@/components/Input2'

    export default {
        components: { Input2 },
        data () {
            return {
                itemType: 'Customer',
                loading: false,
                loadingCards: false,
                total: 0,
                dataTable: [],
                cardsTable: [],
                customerId: this.$route.params.id,
                customerName: ''
            }
        },
        created () {
            this.getCards()
            this.getData()
        },
        methods: {
            getData () {
                this.loading = true

                let request = {
                    Name: "GetItemView",
                    ItemType: "Customer",
                    OperatorName: "Admin",
                    ItemId: this.customerId
                }

                this.$api.Main.getCustomers(request).then(response => {
                    this.loading = false
                    this.dataTable = response.Parameters

                    this.dataTable.map(row => {
                        if (row.View.Name === 'Name') this.customerName = row.Value
                    })
                }).catch (() => {
                    this.loading = false
                })
            },
            getCards () {
                this.loadingCards = true

                let request = {
                    Name: "GetItemsList",
                    ItemType: "Card"
                }
                request.Filter = {
                    Type: "Simple",
                    Field: "CustomerID",
                    Operation: "Equal",
                    Value: this.customerId
                }

                this.$api.Main.getCards(request).then(response => {
                    this.loadingCards = false
                    this.cardsTable = response.Items
                    this.total = response.Total
                }).catch (() => {
                    this.loadingCards = false
                })
            },
            showDetails (id) {
                this.$router.push({ name: 'cardDetails', params: { id: id } })
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
